module.exports = __webpack_public_path__ + "static/media/sf-test-15.0428eb4a.mp3";